import React, { useState } from "react";
import styled from "styled-components";
import { DynamicModal } from "@/shared/components/Modal/DynamicModal";
import { CUSTOM_COLORS } from "@/shared/theme/colorUtils";
import { clearCreatorWelcomePending, isCreatorWelcomePending } from "../utils/creatorWelcomeSession";

const FirstName = styled.span`
	color: ${CUSTOM_COLORS.PRIMARY};
`;

interface CreatorWelcomeModalProps {
	creatorName: string;
	creatorEmail: string;
	onContinue?: () => Promise<void> | void;
}

export const CreatorWelcomeModal: React.FC<CreatorWelcomeModalProps> = ({ creatorName, creatorEmail, onContinue }) => {
	const [open, setOpen] = useState(() => isCreatorWelcomePending(creatorEmail));
	const [loading, setLoading] = useState(false);

	const continueToDashboard = async () => {
		setLoading(true);
		try {
			await onContinue?.();
			clearCreatorWelcomePending();
			setOpen(false);
		} finally {
			setLoading(false);
		}
	};

	const firstName = creatorName.trim().split(/\s+/)[0] || "Creator";
	return (
		<DynamicModal
			open={open}
			onCancel={() => undefined}
			onConfirm={continueToDashboard}
			title={
				<>
					Welcome to Creatorverse <FirstName>{firstName}</FirstName>!
				</>
			}
			description="Step into a world where you can be a part of exciting campaigns!"
			icon={<img src="/Welcome.png" alt="" style={{ width: "100%", maxWidth: 430, display: "block" }} />}
			confirmText="Continue to Dashboard"
			width={600}
			centered
			singleOutlineAction
			closable={false}
			loading={loading}
		/>
	);
};
